"use client";

import { CLARITY_APP_ID } from "@/_config";
import Script from "next/script";

export default function Clarity() {
  const projectId = CLARITY_APP_ID;
  const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  const shouldLoad = Boolean(projectId) && process.env.NODE_ENV === 'production' && !isLocalHost;

  if (!shouldLoad) return null;

  return (
    <Script id="microsoft-clarity" strategy="afterInteractive">
      {`
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);
            t.async=1;
            t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${projectId}");
      `}
    </Script>
  );
}